import type { RankingResultCount } from "../types/callRanking";
import { RANKING_RESULT_COUNT_OPTIONS } from "../types/callRanking";

export const isValidRankingResultCount = (value: number): value is RankingResultCount =>
  (RANKING_RESULT_COUNT_OPTIONS as readonly number[]).includes(value);
